import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import cx from "classnames";
import { Text, ScreenReaderText } from "@cinch-labs/design-system";
import skeletonStyles from "../../skeleton.module.css";
import styles from "./price.module.css";
import { sendDigitalDataEvent } from "@cinch-nx/shared-analytics";
import { useFinanceDrawerContext } from "../../../../context/finance-drawer-context";
import AdminFeeButton from "../admin-fee-button/admin-fee-button";
export const numberWithCommas = (x)=>{
    if (typeof x === "string") {
        return Number.parseInt(x.replace(/,/g, ""), 10).toLocaleString();
    }
    return Math.round(x).toLocaleString();
};
const penceToPounds = (n)=>Math.round(n / 100);
const hasAValidQuote = (n)=>typeof n === "number" && n > 0;
const Price = ({ price , vehicleId , shouldShowCarsOnOfferTag =false , shouldShowDepositContribution =false , discountInPence , quoteRegularPaymentInPence , quoteType , isPending , onAdminFeesClick  })=>{
    const fullPrice = `£${numberWithCommas(price)}`;
    const pricePerMonth = `£${numberWithCommas(penceToPounds(quoteRegularPaymentInPence ?? 0))}`;
    const wasPriceId = `${vehicleId}-was-price`;
    const financeDrawerContext = useFinanceDrawerContext();
    const getWasPrice = ()=>{
        const discount = penceToPounds(discountInPence ?? 0);
        const wasPrice = `£${numberWithCommas(price + discount)}`;
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                "Was ",
                /*#__PURE__*/ _jsx("s", {
                    children: wasPrice
                })
            ]
        });
    };
    const renderPromotionalText = ()=>{
        let text;
        if (shouldShowDepositContribution) {
            text = /*#__PURE__*/ _jsx(_Fragment, {
                children: "Price includes deposit offer"
            });
        } else if (shouldShowCarsOnOfferTag) {
            text = getWasPrice();
        } else {
            return null;
        }
        return /*#__PURE__*/ _jsx(Text, {
            element: "span",
            id: wasPriceId,
            fontSizeFixed: "xs",
            fontWeight: "medium",
            "aria-hidden": true,
            className: cx(styles["promotionText"], {
                [skeletonStyles["base"]]: isPending,
                [skeletonStyles["active"]]: isPending,
                [styles["rightAligned"]]: shouldShowDepositContribution
            }),
            children: text
        });
    };
    const renderCashPrice = ()=>/*#__PURE__*/ _jsxs(Text, {
            element: "span",
            fontSizeFixed: "l",
            fontWeight: "semibold",
            "aria-describedby": discountInPence ? wasPriceId : undefined,
            className: cx(styles["cashPrice"], {
                [skeletonStyles["base"]]: isPending,
                [skeletonStyles["active"]]: isPending
            }),
            children: [
                /*#__PURE__*/ _jsx(ScreenReaderText, {
                    element: "span",
                    role: "presentation",
                    children: "Full price."
                }),
                `${fullPrice}`
            ]
        });
    return /*#__PURE__*/ _jsxs("div", {
        className: styles["marginTop"],
        children: [
            renderPromotionalText(),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles["priceContainer"],
                        children: [
                            renderCashPrice(),
                            hasAValidQuote(quoteRegularPaymentInPence) && /*#__PURE__*/ _jsxs(Text, {
                                element: "span",
                                fontSizeFixed: "l",
                                fontWeight: "semibold",
                                className: cx(styles["pricePerMonth"], {
                                    [skeletonStyles["base"]]: isPending,
                                    [skeletonStyles["active"]]: isPending
                                }),
                                children: [
                                    /*#__PURE__*/ _jsx(ScreenReaderText, {
                                        element: "span",
                                        role: "presentation",
                                        children: `Price per month. ${quoteType}. `
                                    }),
                                    pricePerMonth
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles["priceInfoContainer"],
                        children: [
                            /*#__PURE__*/ _jsx(AdminFeeButton, {
                                isPending: isPending,
                                onAdminFeeClick: onAdminFeesClick
                            }),
                            hasAValidQuote(quoteRegularPaymentInPence) && (financeDrawerContext && quoteType ? /*#__PURE__*/ _jsx(Text, {
                                element: "button",
                                className: styles["quoteTypeButton"],
                                onClick: ()=>{
                                    sendDigitalDataEvent({
                                        event: {
                                            name: "click",
                                            category: "HP & PCP information",
                                            label: "info",
                                            action: "view",
                                            value: quoteType
                                        }
                                    });
                                    financeDrawerContext.setIsShowingFinanceDrawer(true);
                                },
                                fontSizeFixed: "xs",
                                "aria-label": `Find more information on ${quoteType}`,
                                children: ` /month ${quoteType.toUpperCase()}`
                            }) : /*#__PURE__*/ _jsx(Text, {
                                element: "small",
                                fontSizeFixed: "xs",
                                "aria-hidden": true,
                                children: ` /month ${quoteType === null || quoteType === void 0 ? void 0 : quoteType.toUpperCase()}`
                            }))
                        ]
                    })
                ]
            })
        ]
    });
};
export default Price;
